<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <Button icon="ios-arrow-back" size="small" class="mr20" @click="$router.go(-1)">返回</Button>
        <span class="ivu-page-header-title mr20" v-text="$route.meta.title"></span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">

      <Row :gutter="16" type="flex" style="margin-left: 100px" class-name="info-block">
        <Col span="24">
          <Row :gutter="16" type="flex" justify="end" class-name="info-row">
            <Col span="5" class-name="info-title">负责圈舍</Col>
            <Col span="1">:</Col>
            <Col span="18" class-name="info-content">{{infoData.house_name}}</Col>
          </Row>
          <Divider class="ivu-mt ivu-mb" style="background: #fff"/>

          <Row :gutter="16" type="flex" justify="end" class-name="info-row">
            <Col span="5" class-name="info-title">姓名</Col>
            <Col span="1">:</Col>
            <Col span="18" class-name="info-content">{{infoData.real_name}}</Col>
          </Row>
          <Divider class="ivu-mt ivu-mb" style="background: #fff"/>

          <Row :gutter="16" type="flex" justify="end" class-name="info-row">
            <Col span="5" class-name="info-title">性别</Col>
            <Col span="1">:</Col>
            <Col span="18" class-name="info-content">{{infoData.gender_msg}}</Col>
          </Row>
          <Divider class="ivu-mt ivu-mb" style="background: #fff"/>

          <Row :gutter="16" type="flex" justify="end" class-name="info-row">
            <Col span="5" class-name="info-title">联系电话</Col>
            <Col span="1">:</Col>
            <Col span="18" class-name="info-content">{{infoData.phone}}</Col>
          </Row>
          <Divider class="ivu-mt ivu-mb" style="background: #fff;"/>

          <Row :gutter="16" type="flex" justify="end" class-name="info-row">
            <Col span="5" class-name="info-title">岗位</Col>
            <Col span="1">:</Col>
            <Col span="18" class-name="info-content">{{infoData.job}}</Col>
          </Row>

        </Col>

      </Row>
    </card>

  </div>
</template>
<style>

.info-block {
  background-color: #f4f4f4;
  border-radius: 20px;
  width: 50%;
}

.info-row {
  margin: 10px 0;
}

.info-title {
  text-align: end;
}

.info-content {

}

</style>
<script>
import { cattleUserDetailApi } from '@/api/cattleFarm/cattleUser'

export default {
  name: 'cattleUserInfo',
  data() {
    return {
      infoData: {
        house_name: '',
        real_name: '',
        gender_msg: '',
        phone: '',
        job: '',
      },
    }
  },
  mounted() {
    if (this.$route.params.id !== '0' && this.$route.params.id) {
      this.loadInfoData(this.$route.params.id)
    }
  },
  methods: {
    // 加载数据
    loadInfoData(id) {
      cattleUserDetailApi(id).then(res => {
        //数据赋值
        this.infoData = res.data

      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

  }
}
</script>
